import _classCallCheck from "C:\\Users\\benja\\Documents\\projects\\dev\\jam-pad-2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";

/**
 * @module decoding
 */
import * as buffer from './buffer.js';
/**
 * A Decoder handles the decoding of an Uint8Array.
 */

export var Decoder =
/**
 * @param {Uint8Array} uint8Array Binary data to decode
 */
function Decoder(uint8Array) {
  _classCallCheck(this, Decoder);

  this.arr = uint8Array;
  this.pos = 0;
};
/**
 * @function
 * @param {Uint8Array} uint8Array
 * @return {Decoder}
 */

export var createDecoder = function createDecoder(uint8Array) {
  return new Decoder(uint8Array);
};
/**
 * @function
 * @param {Decoder} decoder
 * @return {boolean}
 */

export var hasContent = function hasContent(decoder) {
  return decoder.pos !== decoder.arr.length;
};
/**
 * Clone a decoder instance.
 * Optionally set a new position parameter.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} [newPos] Defaults to current position
 * @return {Decoder} A clone of `decoder`
 */

export var clone = function clone(decoder) {
  var newPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : decoder.pos;

  var _decoder = createDecoder(decoder.arr);

  _decoder.pos = newPos;
  return _decoder;
};
/**
 * Create an Uint8Array view of the next `len` bytes and advance the position by `len`.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} len The length of bytes to read
 * @return {Uint8Array}
 */

export var readUint8Array = function readUint8Array(decoder, len) {
  var view = buffer.createUint8ArrayViewFromArrayBuffer(decoder.arr.buffer, decoder.pos, len);
  decoder.pos += len;
  return view;
};
/**
 * Read variable length Uint8Array.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */

export var readVarUint8Array = function readVarUint8Array(decoder) {
  return readUint8Array(decoder, readVarUint(decoder));
};
/**
 * Read the rest of the content as an ArrayBuffer
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */

export var readTailAsUint8Array = function readTailAsUint8Array(decoder) {
  return readUint8Array(decoder, decoder.arr.length - decoder.pos);
};
/**
 * Skip one byte, jump to the next position.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} The next position
 */

export var skip8 = function skip8(decoder) {
  return decoder.pos++;
};
/**
 * Read one byte as unsigned integer.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} Unsigned 8-bit integer
 */

export var readUint8 = function readUint8(decoder) {
  return decoder.arr[decoder.pos++];
};
/**
 * Read 2 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */

export var readUint16 = function readUint16(decoder) {
  var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
  decoder.pos += 2;
  return uint;
};
/**
 * Read 4 bytes as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */

export var readUint32 = function readUint32(decoder) {
  var uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
  decoder.pos += 4;
  return uint;
};
/**
 * Look ahead without incrementing position.
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */

export var peekUint8 = function peekUint8(decoder) {
  return decoder.arr[decoder.pos];
};
/**
 * Look ahead without incrementing position.
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */

export var peekUint16 = function peekUint16(decoder) {
  return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
};
/**
 * Look ahead without incrementing position.
 * to the next byte and read it as unsigned integer.
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.
 */

export var peekUint32 = function peekUint32(decoder) {
  return decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
};
/**
 * Read unsigned integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */

export var readVarUint = function readVarUint(decoder) {
  var num = 0;
  var len = 0;

  while (true) {
    var r = decoder.arr[decoder.pos++];
    num = num | (r & 127) << len;
    len += 7;

    if (r < 1 << 7) {
      return num >>> 0; // return unsigned number!
    }
    /* istanbul ignore if */


    if (len > 35) {
      throw new Error('Integer out of range!');
    }
  }
};
/**
 * Look ahead and read varUint without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {number}
 */

export var peekVarUint = function peekVarUint(decoder) {
  var pos = decoder.pos;
  var s = readVarUint(decoder);
  decoder.pos = pos;
  return s;
};
/**
 * Read string of variable length
 * * varUint is used to store the length of the string
 *
 * Transforming utf8 to a string is pretty expensive. The code performs 10x better
 * when String.fromCodePoint is fed with all characters as arguments.
 * But most environments have a maximum number of arguments per functions.
 * For effiency reasons we apply a maximum of 10000 characters at once.
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String.
 */

export var readVarString = function readVarString(decoder) {
  var remainingLen = readVarUint(decoder);
  var encodedString = '';

  while (remainingLen > 0) {
    var nextLen = remainingLen < 10000 ? remainingLen : 10000;
    var bytes = new Array(nextLen);

    for (var i = 0; i < nextLen; i++) {
      bytes[i] = decoder.arr[decoder.pos++];
    }

    encodedString += String.fromCodePoint.apply(null, bytes);
    remainingLen -= nextLen;
  }

  return decodeURIComponent(escape(encodedString));
};
/**
 * Look ahead and read varString without incrementing position
 *
 * @function
 * @param {Decoder} decoder
 * @return {string}
 */

export var peekVarString = function peekVarString(decoder) {
  var pos = decoder.pos;
  var s = readVarString(decoder);
  decoder.pos = pos;
  return s;
};